import { useEffect, useMemo, useState } from "react";
import { fetchPublicProperties } from "../services/publicPropertyApi";

const usePublicProperties = (params = {}) => {
  const queryKey = useMemo(() => JSON.stringify(params), [params]);
  const [properties, setProperties] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const requestParams = JSON.parse(queryKey);
    let mounted = true;
    setLoading(true);
    setError("");

    fetchPublicProperties(requestParams)
      .then((result) => {
        if (!mounted) {
          return;
        }
        setProperties(result.data);
        setMeta(result.meta);
      })
      .catch((requestError) => {
        if (mounted) {
          setError(requestError.message);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [queryKey]);

  return { properties, meta, loading, error };
};

export default usePublicProperties;
